import { useState } from 'react';

import { Popover, PopoverContent, PopoverPortal, PopoverTrigger } from '../core/Popover';

const HoverPopover = ({
    triggerContent,
    children,
}: {
    triggerContent: React.ReactNode;
    children: React.ReactNode;
}) => {
    const [open, setOpen] = useState(false);

    return (
        <Popover open={open}>
            <PopoverTrigger
                asChild
                onMouseEnter={() => setOpen(true)}
                onMouseLeave={() => setOpen(false)}
                onClick={(e) => e.stopPropagation()}
            >
                {triggerContent}
            </PopoverTrigger>
            <PopoverPortal>
                <PopoverContent
                    className="tw-popover-content"
                    side="left"
                    sideOffset={-15}
                    onMouseEnter={() => setOpen(true)}
                    onMouseLeave={() => setOpen(false)}
                    onClick={(e) => e.stopPropagation()}
                >
                    {children}
                </PopoverContent>
            </PopoverPortal>
        </Popover>
    );
};

export default HoverPopover;
